import { SetBundleBusinessModelInput } from 'generated/graphql';
import { BundleFormValues } from './priceFormSchemas';
import { mapPriceValueForInput } from './editBundle.vm.mapper';
import {
  MigrateToBundleDispatcher,
  MigrationModalSteps,
} from './migrateToBundle.vm';
import { ButtonVariant } from '@client/new/pages/workout/components/addFromLibrary/mappers';
import { ButtonColor } from '@design-system/components/button/button.css';
import { trackEvent } from '@services/mixpanel';

export const mapInputToSetBundleBusinessModel = (
  values: BundleFormValues,
  creatorId: number,
): SetBundleBusinessModelInput => ({
  annualPriceCents: mapPriceValueForInput({
    updatePriceEnabled: values.annualPriceEnabled,
    updatePrice: values.annualPrice,
  }),
  monthlyPriceCents: mapPriceValueForInput({
    updatePriceEnabled: values.monthlyPriceEnabled,
    updatePrice: values.monthlyPrice,
  }),
  freeTrial: {
    annual: values.annualFreeTrial,
    monthly: values.monthlyFreeTrial,
  },
  influencerId: creatorId,
});

export const getStepCta = ({
  migrationStep,
  dispatch,
  isSubmittingPrice,
}: {
  migrationStep: MigrationModalSteps;
  dispatch: MigrateToBundleDispatcher;
  isSubmittingPrice: boolean;
}) => {
  switch (migrationStep) {
    case 1:
      return [
        {
          title: 'Continue',
          onClick: () => dispatch('setMigrationStep', 2),
        },
      ];
    case 2:
      return [
        {
          title: 'Back',
          onClick: () => dispatch('setMigrationStep', 1),
          variant: 'text' as ButtonVariant,
        },
        {
          title: 'I’m not ready yet',
          onClick: () => dispatch('cancelMigration'),
          variant: 'text' as ButtonVariant,
          className: 'ml-auto mr-2',
          color: 'primary' as ButtonColor,
        },
        {
          title: 'Continue',
          onClick: () => dispatch('setMigrationStep', 3),
        },
      ];
    case 3:
      return [
        {
          title: 'Back',
          onClick: () => dispatch('setMigrationStep', 2),
          variant: 'text' as ButtonVariant,
        },
        {
          title: 'Continue',
          onClick: () => dispatch('setMigrationStep', 4),
        },
      ];
    case 4:
      return [
        {
          title: 'Back',
          onClick: () => dispatch('setMigrationStep', 3),
          variant: 'text' as ButtonVariant,
        },
        {
          title: 'Switch to Exclusive Subscription',
          onClick: () => dispatch('validatePrice'),
          submitting: isSubmittingPrice,
        },
      ];
    case 5:
      return [
        {
          title: 'Back',
          onClick: () => dispatch('setMigrationStep', 4),
          variant: 'text' as ButtonVariant,
        },
        {
          title: 'I’m not ready yet',
          onClick: () => dispatch('cancelMigration'),
          className: 'ml-auto mr-2',
          variant: 'text' as ButtonVariant,
          color: 'primary' as ButtonColor,
        },
        {
          title: 'Confirm switch',
          onClick: () => {
            trackEvent({
              type: 'Exclusive Subscription Created',
            });
            dispatch('migrate');
          },
        },
      ];
    default:
      return [
        {
          title: 'Continue',
          onClick: () => dispatch('setMigrationStep', 2),
        },
      ];
  }
};
